<template>
	<div class="bg_content">
		<div class="device_head">
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 节假日规则</span>
		</div>
		<div class="content_body">
			<el-card shadow="never">
				<el-row :gutter="24">
					<el-col :span="4">
						<el-input placeholder="节假日规则名称" v-model="searchQuery.name" clearable>
						</el-input>
					</el-col>
					<el-col :span="2" style="text-align: right;">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
					</el-col>
					<el-col :span="18" style="text-align: right;">
						<el-button icon="el-icon-plus" type="primary" @click="handleOpenDialog">新增节假日规则</el-button>
					</el-col>
				</el-row>
			</el-card>
			<el-card class="card_table" shadow="never">
				<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580">
					<template slot="empty">
						<div>
							<img src="@/assets/nodata.png" class="nodata" />
							<div class="nodata_text">无数据</div>
						</div>
					</template>
					<el-table-column label="规则名称" prop="name" width="200" />
					<el-table-column label="编号" prop="ruleNumber" width="100">
					</el-table-column>
					<el-table-column label="是否允许通行" prop="permitted" width="150">
						<template slot-scope="scope">
							<div v-if="scope.row.permitted" class="table_scope_t">允许</div>
							<span v-if="!scope.row.permitted" class="table_scope_f">禁止</span>
						</template>
					</el-table-column>
					<el-table-column label="状态" prop="status" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.status" class="table_scope_t">开启</div>
							<span v-if="!scope.row.status" class="table_scope_f">禁用</span>
						</template>
					</el-table-column>
					<el-table-column label="规则时间" prop="rules" width="320">
						<template slot-scope="scope">
							<span v-for="(item,index) in formatterTimes(scope.row.rules)" :key="index"
								class="time_single" @click="handleOpenTimes(scope.row,index)">{{item}}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" width="120">
						<template slot-scope="scope">
							<el-link type="primary" style="margin-right: 25px;"
								@click="handleOpenDialog(scope.row)">编辑</el-link>
							<el-link type="danger" @click="hanldeDelete(scope.row)">删除</el-link>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
					layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
			</el-card>
		</div>

		<holiday-dialog ref="holidayDialogRef" :id="holidayId" @on-load="handleSearch"></holiday-dialog>
		<rule-times-view ref="ruleTimesRef" />
		<company-footer-info />
	</div>
</template>

<script>
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
	import HolidayDialog from "./holidayDialog.vue";
	import RuleTimesView from "./ruleTimesView.vue";
	import { HolidayRuleApi } from "@/api/nexus/holiday"
	export default {
		components: {
			CompanyFooterInfo,
			HolidayDialog,
			RuleTimesView
		},
		data() {
			return {
				//查询条件
				searchQuery: {
					name: '',
					pageSize: 20,
          pageNum: 1,
				},
				//表格数据
				tableData: [],
				tableTotal: 0,
				holidayId: '',
			}
		},
		methods: {
			//点击规则时间
			handleOpenTimes(row, index) {
				this.$refs.ruleTimesRef.show(row.rules[index]);
			},
			//查询
			handleSearch() {
				this.searchQuery.pageNum = 1;
				this.getRuleList();
			},
			//新增编辑
			handleOpenDialog(row) {
				this.holidayId = row.id ? row.id : ''
				this.$nextTick(() => {
					this.$refs?.holidayDialogRef?.show(row.id ? '修改节假日规则' : '新增节假日规则');
				})
			},
			//删除
			async hanldeDelete(row) {
				await this.$confirm("是否确认删除该数据？", "提示")
				let {code} = await HolidayRuleApi.deleteById(row.id);
				if(code == 200){
					this.$message.success("删除成功");
					this.getRuleList()
				}
				
			},
			//规则时间格式化
			formatterTimes(rules) {
				if (rules) {
					return rules.map(item => {
						return item.startDate.concat("~", item.endDate)
					})
				}
				return;
			},
			//下一页
			handleCurrentChange(page) {
				this.searchQuery.page = page;
			},
			//获取数据
			async getRuleList() {
				let { code, data } = await HolidayRuleApi.getHolidayPage(this.searchQuery)
				this.tableData = data.list
				this.tableTotal = parseInt(data.total)
			}
		},
		mounted() {
			this.getRuleList();
		}
	}
</script>

<style>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.content_body {
		margin-top: 20px;
		height: 100%;
	}

	.table_scope_t {
		color: #4192F3;
	}

	.table_scope_f {
		color: #EE7B32;
	}

	.time_single {
		flex: 0 0 116px;
		/* 不伸缩，基准宽度 116px */
		width: 100px;
		/* 实际宽度 100px */
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 16px;
		color: #1a1a1a;
		background: #dee4ed;
		border-radius: 4px;
		margin-right: 8px;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;
		padding: 5px;

	}

	.card_table {
		height: calc(100% - 80px) !important;
	}

	.search-icon {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}
</style>